import { ApiInstance } from '@/lib/api'
import type { Owner, OwnerPayload } from '@/lib/types'
import { cursorParams, type Paginated } from '@/lib/pagination'

export type OwnersListResponse = Paginated<Owner>

export async function listOwners(params?: { cursor?: string; perPage?: number; sort?: string; search?: string; query?: string }) {
  const { data } = await ApiInstance.get<OwnersListResponse>('/real-state/owners', {
    params: {
      ...cursorParams(params?.cursor, params?.perPage ?? 50),
      sort: params?.sort ?? 'name:asc',
      search: params?.search || undefined,
      query: params?.query || undefined
    }
  })
  return data
}

export async function getOwner(id: string) {
  const { data } = await ApiInstance.get<Owner>(`/real-state/owners/${id}`)
  return data
}

export async function createOwner(payload: OwnerPayload) {
  const { data } = await ApiInstance.post<Owner>('/real-state/owners', payload)
  return data
}

export async function updateOwner(id: string, payload: OwnerPayload) {
  const { data } = await ApiInstance.put<Owner>(`/real-state/owners/${id}`, payload)
  return data
}

export async function linkOwnerToRealState(realStateId: string, ownerId: string) {
  const { data } = await ApiInstance.post(`/real-state/${realStateId}/owners/${ownerId}`)
  return data
}

export async function unlinkOwnerFromRealState(realStateId: string, ownerId: string) {
  const { data } = await ApiInstance.delete(`/real-state/${realStateId}/owners/${ownerId}`)
  return data
}
